import { MaskedTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { Row, Col } from 'react-bootstrap';

type IpaAdministrationWizardMemberProviderInfoProps = {
    register: any;
    errors: Record<string, any>;
};

const IpaAdministrationWizardMemberProviderInfo = (
    props: IpaAdministrationWizardMemberProviderInfoProps,
) => {
    return (
        <Row className='accordion-content'>
            <Col md={6}>
                <div className={`e-input-group-margin`}>
                    <div className='e-float-text'>Member Card/IPA Phone *</div>
                    <MaskedTextBoxComponent
                        mask='(000) 000-0000'
                        {...props?.register('ipaPhoneIdCard', {
                            required: true,
                            maxLength: 10,
                            minLength: 10,
                        })}
                    />
                    {props?.errors?.ipaPhoneIdCard && <p className='error-form'>IPA phone is required</p>}
                </div>
            </Col>

            <Col md={6}>
                <div className={`e-float-input e-input-group`}>
                    <input
                        type='text'
                        {...props?.register('ipaNameIdCard', {
                            required: 'IPA Name is required',
                            maxLength: {
                                value: 100,
                                message: 'IPA Name must be maximun 100 characters length',
                            },
                        })}
                    />
                    <span className='e-float-line'></span>
                    <label className='e-float-text'>Member Card/IPA Name *</label>
                </div>
                {props?.errors?.ipaNameIdCard && (
                    <span className='error-form'>{props?.errors?.ipaNameIdCard?.message}</span>
                )}
            </Col>
        </Row>
    );
}

export default IpaAdministrationWizardMemberProviderInfo;